// ======================================================================
// File Name       : CourseAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import { openModal, hideModal } from './ModalAction';
import * as userAttributeActions from './UserAttributeAction';
import * as containerActions from './ContainerAction';
import * as authorityActions from './AuthorityAction';
import * as userActions from './UserAction';
import * as groupActions from '../actions/GroupAction';
import * as courseRequests from './httpRequests/course';
import * as thumbnail from './httpRequests/thumbnail';
import * as itemRequests from './httpRequests/item';
import * as userRequests from './httpRequests/user';
import * as groupRequests from './httpRequests/group';
import * as userAttributeRequests from './httpRequests/userAttribute';
import * as courseActionCreators from './actionCreators/course';
import * as userActionCreators from './actionCreators/user';
import * as ModalIds from '../constants/ModalIds';
import { MODE, RETURN_MAX_NUM, SELECT_TARGET_DATA, DEFAULT_DATE_SHORT_FORMAT_SERVER, RETURN_MAX_NUM_1000, DEFAULT_DATE_FORMAT_SERVER_NO_SECOND, STRUCTURE_TYPE } from '../constants';
import { USER_CREATE_TYPE, USER_TYPE } from '../constants/UserConstants';
import { END_CONDITION_TYPE_FOR_COURSE, CHOSEN_THUMBNAIL, COURSE_GROUP_RELATION_TYPE } from '../constants/CourseConstants';
import { USER_ATTRIBUTE_TYPE } from '../constants/UserAttributeConstants';
import { END_CONDITION_TYPE_FOR_ITEM } from '../constants/ItemConstant';
import * as UserUtils from '../utils/UserUtils';
import { MIN_MAX_DATE_TXT } from '../utils/index';
import { ITEM_IMAGE_TYPE } from '../constants/InitialImageConstants';
import { DATA_AFFIILIATION_TYPE } from '../constants/ContentConstant';
import * as courseUtils from '../utils/CourseUtils';

export function fetchCourseList(param) {
  return dispatch =>
    courseRequests
      .postCourseGetList({
        selectTargetData: SELECT_TARGET_DATA.DATA,
        searchInfo: {
          ...param,
        },
      })
      .then(({ recordNum, courseList }) => {
        dispatch(courseActionCreators.receiveCourseList(recordNum, courseList));
      });
}

export function fetchCourseInfo(courseSecernId) {
  return dispatch =>
    dispatch(
      fetchCourseList({
        searchInfo: {
          courseList: [courseSecernId],
        },
      }),
    );
}

export function handleInputChange(payload) {
  return dispatch => dispatch(courseActionCreators.handleInputChange(payload));
}

export function initDataForRegisterCourseDialog() {
  return async (dispatch) => {
    dispatch(openModal(ModalIds.COURSE_REGISTER_EDIT));
    await dispatch(authorityActions.getAuthorityList());
    dispatch(courseActionCreators.initDataForCourseRegisterDialog());
    dispatch(userAttributeActions.initUserAttributeEditing());
  };
}

/**
 * Handle detail dialog's data
 * @param {String} courseSecernId
 */
export function initDataForDetailEditConfirmDialog(courseSecernId, childItemSercernIdList) {
  return (dispatch) => {
    dispatch(openModal(ModalIds.COURSE_DETAIL));
    const requests = [];

    const courseApiParam = {
      courseList: [courseSecernId],
    };

    const searchInfo = {};

    // fetch course's info
    requests.push(dispatch(fetchCourseList(courseApiParam)));

    // fetch authority info
    requests.push(dispatch(authorityActions.getAuthorityList()));

    // fetch user attribute
    requests.push(dispatch(userAttributeActions.initUserAttributeEditing(USER_ATTRIBUTE_TYPE.COURSE, courseSecernId)));

    // fetch course relation
    requests.push(dispatch(fetchCourseRelation(courseSecernId)));

    // get group course relations
    requests.push(dispatch(getGroupCourseRelation({ courseList: [courseSecernId] })));

    // fetch user group relation
    requests.push(dispatch(groupActions.fetchGroupStructure()));

    // Step 10.2.0 START
    requests.push(dispatch(containerActions.initDataForItemTreeDialog(courseSecernId, STRUCTURE_TYPE.COURSE, false)));
    // Step 10.2.0 END

    Promise.all(requests).then(() => {
      dispatch(courseActionCreators.initDataForDetailEditConfirmDialog(courseSecernId, childItemSercernIdList));
    });
  };
}

export function deleteCourse(courseSecernId) {
  return async (dispatch) => {
    // save course info
    await courseRequests.postCourseEdit(MODE.DELETE_MODE, {
      courseSecernId,
    });
    dispatch(containerActions.deleteCourseStructure(courseSecernId));
  };
}

export function saveCourse() {
  return async (dispatch, getState) => {
    const { course, container } = getState();
    const { editingCourse, editingUser, editType, courseRelations, childItemSercernIdList,
      selectedCourseGroupRelationList, groupCourseRelationList, recordNumGroupCourseRelation } = course;
    const { recordNumUserCourseRelation, endConditionTypeForCourse } = editingCourse;
    const { selectedItemSecernIdList } = container;
    let recordNumCourseRelation = 0;
    if (courseRelations && courseRelations.recordNum) {
      recordNumCourseRelation = courseRelations.recordNum;
    }

    // Step 10.2.0 START
    const isEnableCourseEndCondition = courseUtils.isEnableCourseEndCondition(editingCourse.endConditionTypeForCourse);
    if (isEnableCourseEndCondition) {
      if (editingCourse.endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.PROGRESS) {
        const progressRatioForCourseEnd = editingCourse.progressRatioForCourseEnd
          ? editingCourse.progressRatioForCourseEnd
          : 0;
        editingCourse.progressRatioForCourseEnd = progressRatioForCourseEnd;
      } else {
        delete editingCourse.progressRatioForCourseEnd;
      }
    }
    // Step 10.2.0 END
    const postCourseEditData = { ...editingCourse };
    if (postCourseEditData) {
      // #7230 START
      postCourseEditData.publicPeriodFrom = parseDateTime(postCourseEditData, 'publicPeriodFrom', DEFAULT_DATE_SHORT_FORMAT_SERVER);
      postCourseEditData.publicPeriodTo = parseDateTime(postCourseEditData, 'publicPeriodTo', DEFAULT_DATE_SHORT_FORMAT_SERVER);
      // #7230 END
      if (postCourseEditData.dataUrl) {
        delete postCourseEditData.dataUrl;
      }
      if (postCourseEditData.imageUploadFileName) {
        delete postCourseEditData.imageUploadFileName;
      }
      if (postCourseEditData.thumbnailUrl) {
        delete postCourseEditData.thumbnailUrl;
      }

      // Step 10.2.0 START
      if (
        isEnableCourseEndCondition &&
        postCourseEditData.endConditionTypeForCourse !== END_CONDITION_TYPE_FOR_COURSE.NONE
      ) {
        postCourseEditData.itemListForCourseEnd = selectedItemSecernIdList;
      }
      // Step 10.2.0 END
      // STEP12.3.0 TAS-21349 START
      if (!Object.values(END_CONDITION_TYPE_FOR_COURSE).includes(postCourseEditData.endConditionTypeForCourse)) {
        postCourseEditData.endConditionTypeForCourse = null;
      }
      // STEP12.3.0 TAS-21349 END
    }
    // Remove GUI, un-used variable
    delete postCourseEditData.limitPublicPeriod;
    delete postCourseEditData.createdAt;
    delete postCourseEditData.updatedAt;
    delete postCourseEditData.imageFileSelectType;
    delete postCourseEditData.dataAffiliationType;
    delete postCourseEditData.displayOrder;
    delete postCourseEditData.imageUploadFile;

    // save course info
    let courseSecernId = editingCourse.courseSecernId;
    if ((editingCourse && editingCourse.dataAffiliationType
      === DATA_AFFIILIATION_TYPE.INTERNAL) || editType === MODE.NEW_MODE) {
      const courseRes = await courseRequests.postCourseEdit(editType, postCourseEditData);
      courseSecernId = courseRes.courseSecernId;
    }

    // save course relation, course user attribute
    if (recordNumCourseRelation <= RETURN_MAX_NUM_1000) {
      const storedRelations = courseRelations && courseRelations.allSecernIds ? courseRelations.allSecernIds : [];
      const deletedUsers = storedRelations.reduce((acc, userSecernId) => {
        if (!editingUser[userSecernId]) {
          acc.push({ userSecernId });
        }
        return acc;
      }, []);

      const edittedUsers = storedRelations.reduce((acc, userSecernId) => {
        if (editingUser[userSecernId]) {
          editingUser[userSecernId].attendingPeriodFrom = parseDateTime(editingUser[userSecernId], 'attendingPeriodFrom');
          editingUser[userSecernId].attendingPeriodTo = parseDateTime(editingUser[userSecernId], 'attendingPeriodTo');
          delete editingUser[userSecernId].superuserSecernId; // Step 11.2.0 #17960
          const userType = parseInt(editingUser[userSecernId].userType, 10);
          if (!recordNumUserCourseRelation ||
            (recordNumUserCourseRelation && userType !== USER_TYPE.ADMIN)) {
            acc.push(editingUser[userSecernId]);
          }
          delete editingUser[userSecernId];
        }
        return acc;
      }, []);

      const registeredUsers = Object.keys(editingUser).reduce((acc, userSecernId) => {
        if (editingUser[userSecernId]) {
          editingUser[userSecernId].attendingPeriodFrom = parseDateTime(editingUser[userSecernId], 'attendingPeriodFrom');
          editingUser[userSecernId].attendingPeriodTo = parseDateTime(editingUser[userSecernId], 'attendingPeriodTo');
          acc.push(editingUser[userSecernId]);
        }
        return acc;
      }, []);
      if (registeredUsers && registeredUsers.length) {
        await courseRequests.postUserCourseRelationEdit(MODE.NEW_MODE, {
          courseSecernId,
          userList: registeredUsers,
        });
      }
      if (edittedUsers && edittedUsers.length) {
        await courseRequests.postUserCourseRelationEdit(MODE.EDIT_MODE, {
          courseSecernId,
          userList: edittedUsers,
        });
      }
      if (deletedUsers && deletedUsers.length) {
        await courseRequests.postUserCourseRelationEdit(MODE.DELETE_MODE, {
          courseSecernId,
          userList: deletedUsers,
        });
      }
    }
    if (recordNumGroupCourseRelation <= RETURN_MAX_NUM_1000) {
      const editingGroupCourse = selectedCourseGroupRelationList.reduce((newData, curr) => {
        curr.attendingPeriodFrom = parseDateTime(curr, 'attendingPeriodFrom');
        curr.attendingPeriodTo = parseDateTime(curr, 'attendingPeriodTo');
        delete curr.courseSecernId;
        delete curr.index;
        if (curr.courseGroupRelationType !== COURSE_GROUP_RELATION_TYPE.INDIRECT) {
          delete curr.courseGroupRelationType;
          newData.push(curr);
        }
        return newData;
      }, []);
      // Save course relation to group
      const selectedGroupCourseIds = editingGroupCourse.reduce((ids, curr) => {
        ids.push(curr.groupSecernId);
        return ids;
      }, []);
      // Collect update list
      const editCourseGroup = editingGroupCourse.reduce((editList, curr) => {
        if (!curr.addNew && selectedGroupCourseIds.indexOf(curr.groupSecernId) !== -1 &&
        curr.courseGroupRelationType !== COURSE_GROUP_RELATION_TYPE.INDIRECT) {
          editList.push(curr);
        }
        return editList;
      }, []);
      // Collect register list
      const registerCourseGroup = editingGroupCourse.reduce((registerList, curr) => {
        if (curr.addNew) {
          delete curr.addNew;
          registerList.push(curr);
        }
        return registerList;
      }, []);
      // Collect delete group
      const deleteCourseGroup = groupCourseRelationList.reduce((deleteList, curr) => {
        if (selectedGroupCourseIds.indexOf(curr.groupSecernId) === -1 &&
        curr.courseGroupRelationType !== COURSE_GROUP_RELATION_TYPE.INDIRECT) {
          deleteList.push(curr);
        }
        return deleteList;
      }, []);
  
      if (editCourseGroup.length > 0) {
        await courseRequests.postGroupCourseRelationEdit(MODE.EDIT_MODE, {
          courseSecernId,
          groupList: editCourseGroup,
        });
      }
  
      if (registerCourseGroup.length > 0) {
        await courseRequests.postGroupCourseRelationEdit(MODE.NEW_MODE, {
          courseSecernId,
          groupList: registerCourseGroup,
        });
      }
  
      if (deleteCourseGroup.length > 0) {
        await courseRequests.postGroupCourseRelationEdit(MODE.DELETE_MODE, {
          courseSecernId,
          groupList: deleteCourseGroup,
        });
      }
    }

    const data = { ...editingCourse };
    const uploadThumnail = {
      thumbnailTargetType: 0,
      thumbnailTargetSecernId: courseSecernId,
      imageFileSelectType: data.imageFileSelectType,
      imageFileUpload: data.imageUploadFile,
    };
    await dispatch(userAttributeActions.saveUserAttribute(USER_ATTRIBUTE_TYPE.COURSE, courseSecernId, editType));
    if (data && data.imageFileSelectType && data.imageFileSelectType == CHOSEN_THUMBNAIL.MANUAL && data.imageUploadFile) {
      await thumbnail.editThumnail(uploadThumnail);
    }
    if (editType == MODE.EDIT_MODE && data.imageFileSelectType == CHOSEN_THUMBNAIL.DEFAULT) {
      const uploadThumnailDefault = {
        thumbnailTargetType: 0,
        thumbnailTargetSecernId: courseSecernId,
        imageFileSelectType: CHOSEN_THUMBNAIL.DEFAULT,
      };

      await thumbnail.editThumnail(uploadThumnailDefault);
    }
    dispatch(containerActions.init());
    return dispatch(hideModal());
  };
}

function parseDateTime(obj, key, format) {
  if (obj && obj[key]) {
    if (obj[key] === MIN_MAX_DATE_TXT) {
      obj[key] = '';
    } else {
      // #7230 START
      obj[key] = moment(obj[key]).format(format || DEFAULT_DATE_FORMAT_SERVER_NO_SECOND);
      // #7230 END
    }
    return obj[key];
  }
  return '';
}

export function editingUserSearchCondition(payload) {
  return courseActionCreators.doReceiveSearchCondition(payload);
}

export function searchUser({
  startPosition,
  userSecernIdList,
  returnMaxNum = RETURN_MAX_NUM,
  userAttributeKeyNum,
  userAttributeSearchText,
  managementAuthoritySecernId,
  userName,
  loginId,
  userType,
  selectedGroup: { groupSecernId } = {},
}) {
  return async (dispatch, getState) => {
    let searchByUserAtribute = (async () => userSecernIdList || [])();
    let isAttr = false;
    if (userAttributeSearchText) {
      isAttr = true;
      searchByUserAtribute = userAttributeRequests
        .postUserAttributeGetList({
          searchInfo: {
            userAttributeType: USER_ATTRIBUTE_TYPE.USER,
            userAttributeKeyNum,
            userAttributeSearchText,
          },
        })
        .then(({ userAttributeList }) => userAttributeList.map(cur => cur.secernId));
    }

    const userSecernIds = await searchByUserAtribute;
    if (!userSecernIds.length && isAttr) {
      return dispatch(courseActionCreators.doReceiveUserSearchResult(startPosition, 0, []));
    }
    let searchInfo = {};
    const managementAuthorityList = [];
    userType = parseInt(userType, 10);
    if (managementAuthoritySecernId != null && managementAuthoritySecernId !== '' && userType === USER_TYPE.ADMIN) {
      managementAuthorityList.push(managementAuthoritySecernId);
    }
    searchInfo.userType = userType;
    managementAuthoritySecernId && (searchInfo.managementAuthorityList = [managementAuthoritySecernId]);
    searchInfo.userName = userName;
    loginId && (searchInfo.loginId = loginId);
    searchInfo.userSecernIdList = userSecernIds;
    searchInfo.startPosition = startPosition;
    searchInfo.returnMaxNum = returnMaxNum;
    groupSecernId && (searchInfo.groupList = [groupSecernId]);

    const { recordNum, userList } = await userRequests.postUserGetList({ searchInfo });
    if (!userList || !userList.length) {
      return dispatch(courseActionCreators.doReceiveUserSearchResult(startPosition, recordNum, userList));
    }

    searchInfo = {
      startPosition: 0,
      userList: userList.map(({ userSecernId }) => userSecernId),
    };
    const { groupRelationList } = await groupRequests.postUserGroupRelationGetList({ searchInfo });
    if (!groupRelationList || !groupRelationList.length) {
      return dispatch(courseActionCreators.doReceiveUserSearchResult(startPosition, recordNum, userList));
    }

    const groupList = (await dispatch(userActions.getGroupList(undefined, true))).groupList;

    const groupListByUser = UserUtils.convertObjectToList(groupRelationList, 'userSecernId', 'groupSecernId');
    userList.map((user, index) => {
      const groupSecernIdList =
        groupListByUser[user.userSecernId] && groupListByUser[user.userSecernId].groupSecernId
          ? groupListByUser[user.userSecernId].groupSecernId
          : [];
      const nameGroup = UserUtils.convertGroupListIdToGroupName(groupSecernIdList, groupList);
      user.groupName = nameGroup;
      return user;
    });
    return dispatch(courseActionCreators.doReceiveUserSearchResult(startPosition, recordNum, userList));
  };
}

export function addRemoveUser(userSecernId) {
  return courseActionCreators.addRemoveUser(userSecernId);
}

export function addRemoveAllUser() {
  return courseActionCreators.addRemoveAllUser();
}

export function addUserRelation() {
  return courseActionCreators.addUserRelation();
}

export function removeUserRelation(userSecernId) {
  return courseActionCreators.removeUserRelation(userSecernId);
}

export function removeAllUserRelation(isAdminHasCourseRelation) {
  return courseActionCreators.removeAllUserRelation(isAdminHasCourseRelation);
}

export function editPeriodTime(userSecernId, payload) {
  return courseActionCreators.editPeriodTime(userSecernId, payload);
}

export function changeEditType(editType) {
  return courseActionCreators.changeEditType(editType);
}
export function resetData() {
  return courseActionCreators.resetData();
}
export function changeData() {
  return courseActionCreators.changeData();
}

/**
 * Fetch course user relation info
 * @param {String} courseSecernId
 */
function fetchCourseRelation(courseSecernId) {
  return async (dispatch) => {
    const { recordNum, courseRelationList } = await courseRequests.postUserCourseRelationGetList({
      searchInfo: {
        courseList: [courseSecernId],
      },
      selectTargetData: SELECT_TARGET_DATA.DATA,
    });

    // Fetch user list
    const userSecernIdList = courseRelationList.map(({ userSecernId }) => userSecernId);
    if (userSecernIdList.length) {
      const { userList } = await userRequests.postUserGetList({
        searchInfo: { userSecernIdList, userCreateType: USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER },
      });
      dispatch(courseActionCreators.doReceiveUserList(userList));
    }
    dispatch(courseActionCreators.receiveCourseRelation(recordNum, courseRelationList));
  };
}

export function resetCourseCondition(courseSecernId) {
  return dispatch =>
    courseRequests.postResetCourseCondition({
      courseSecernId,
    }).then(() => {
      dispatch(courseActionCreators.receiveResetCourseCondition());
    });
}

export function getDefaultThumbnail() {
  return async (dispatch) => {
    const searchInfo = {
      imageTypeList: [ITEM_IMAGE_TYPE.COURSE],
    };
    const thumbnailDefault = await thumbnail.defaultThumbnail({ searchInfo });
    return dispatch(courseActionCreators.getThumbnailDefault(thumbnailDefault));
  };
}

export function getUserCourseRelation(userSecernId) {
  return async (dispatch) => {
    const searchInfo = {
      userList: [userSecernId],
    };
    const param = {
      searchInfo,
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const response = await courseRequests.postUserCourseRelationGetList(param);
    let recordNumUserCourseRelation = 0;
    if (response && response.recordNum) {
      recordNumUserCourseRelation = response.recordNum;
    }
    return dispatch(courseActionCreators.getUserCourseRelation(recordNumUserCourseRelation));
  };
}


export function addCourseGroupRelation(group) {
  return courseActionCreators.addCourseGroupRelation(group);
}

export function removeCourseGroupRelation(index) {
  return courseActionCreators.removeCourseGroupRelation(index);
}

export function removeAllCourseGroupRelation(isAdminHasCourseRelation) {
  return courseActionCreators.removeAllCourseGroupRelation(isAdminHasCourseRelation);
}

export function editGroupPeriodTime(groupSecernId, payload) {
  return courseActionCreators.editGroupPeriodTime(groupSecernId, payload);
}

export function getGroupCourseRelation(searchParam) {
  return async (dispatch) => {
    const searchInfo = { ...searchParam };
    const param = {
      searchInfo,
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    const response = await courseRequests.postGroupCourseRelationGetList(param);
    if (response) {
      return dispatch(courseActionCreators.doReceiveGroupCourseList(response));
    }
    return {};
  };
}

// Step 10.2.0 START
export function saveDetailSettingState(name, value) {
  return courseActionCreators.saveDetailSettingState(name, value);
}
// Step 10.2.0 END
